type UnauthorizedHandler = () => void;

let handler: UnauthorizedHandler | null = null;

/**
 * Registers the app-level reaction to a dead session. `requestServerAction` lives below the
 * session layer and cannot call `logout` itself, so the app registers a handler once in
 * `SessionProvider` and the fetch layer calls it via {@link notifyUnauthorized}.
 * Returns an unregister function for cleanup.
 */
export function registerUnauthorizedHandler(fn: UnauthorizedHandler): () => void {
  handler = fn;
  return () => {
    if (handler === fn) {
      handler = null;
    }
  };
}

/**
 * Signals that a server action came back 401. Covers the mutation/toast path, which never
 * reaches React Query's cache or an error boundary — the two places that already logout.
 */
export function notifyUnauthorized(): void {
  handler?.();
}
